import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { captureException, withScope } from '@sentry/browser';
import { customerServiceNumber, customerServiceNumberDial } from 'Utils/getCustomerServicePhone';

class ErrorBoundary extends Component {

  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  constructor (props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      eventId: null
    };
  }

  static getDerivedStateFromError (error) {
    return {
      hasError: true,
      error
    };
  }

  componentDidCatch (error, info) {

    withScope( scope => {
      scope.setExtras(info);
      const eventId = captureException(error);

      this.setState({ eventId });
    });
    if (error.name === 'ChunkLoadError' && typeof window !== 'undefined') {
      this.pageReload();
    }
  }

  pageReload = () => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      document.location.reload(true);
    }
  };

  pageRedirectHome = () => {
    if (typeof window !== 'undefined') {
      window.location.replace('/');
    }
  };

  callCenter = () => {
    if (typeof window !== 'undefined') {
      window.location.href = customerServiceNumberDial;
    }
  };

  render () {

    if (this.state.hasError) {
      return (<span>
        <div className='error-boundary'>
          <div className='error-boundary__title'>
            Bir Hata Oluştu!
          </div>
          <div className='error-boundary__desc'>
            { this.state.error.toString() }
          </div>

          <div className='error-boundary__link' onClick={ this.pageReload }>&raquo; Mevcut Sayfayı Yenile !</div>
          <div className='error-boundary__link' onClick={ this.pageRedirectHome }>&raquo; Ana Sayfa&apos;ya Git !</div>
          <div className='error-boundary__link' onClick={ this.callCenter }>&raquo; Müşteri Hizmetleri&apos;ni ara ({ customerServiceNumber }) !</div>
        </div>
      </span>);
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
